import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'userRole'
})
export class UserRolePipe implements PipeTransform {

  transform(value: number): any {
    if (value === 0)
        return 'User'
    else if(value === 1)
        return 'Admin'
    else if(value === 2)
        return 'Documenter'

    return '';
  }
  
}
